<!-- Hero Section -->
<section class="flex flex-col lg:flex-row gap-4 py-10 px-[5%] w-full">
    <div class="flex flex-col xl:w-1/3 justify-center gap-4">
        <h1 id="main-content" tabindex="-1">
            <span
                class="block font-shBreeHeadline text-3xl sm:text-5xl xl:text-6xl leading-none text-[rgb(var(--ui-1))]"
            >
                {{ 'home.welcome' | translate }}
            </span>
            <span
                class="block font-shBreeHeadline text-3xl sm:text-5xl xl:text-6xl leading-none text-[rgb(var(--ui-2))]"
            >
                {{ 'home.app-name' | translate }}
            </span>
        </h1>

        <p class="max-w-[500px]">
            {{ 'home.subheadline' | translate }}
        </p>

        <div>
            <app-button-link
                [link]="dashBoardRoute()"
                [ariaLabel]="'home.apply' | translate"
                color="primary"
                [label]="'home.apply' | translate"
            />
        </div>
    </div>
    <div class="flex w-full items-center xl:w-2/3 lg:justify-end">
        <img src="assets/images/family-picture.jpg" alt="" class="w-full lg:w-3/4" />
    </div>
</section>

@let title = 'font-shBreeHeadline text-[30px] xl:text-[40px] text-[rgb(var(--ui-2))] lg:leading-normal lg:font-bold';
@let subTitle = 'block w-full font-shBreeHeadline text-2xl xl:text-subHeadingBold leading-tight lg:leading-normal';
<!-- Main Section -->
<section class="relative flex flex-col gap-12 overflow-hidden py-8 px-[10%] w-full">
    <!-- Bullet 1 -->
    <div class="relative z-10 flex flex-col gap-6 lg:flex-row lg:items-center">
        <img
            class="block scale-x-[-1] aspect-square w-[73px]"
            [ngSrc]="'assets/images/cloud.svg'"
            width="73"
            height="73"
            alt=""
        />
        <div id="bullet-1-text" class="flex flex-col justify-center items-start gap-4 lg:pl-4">
            <h2 class="{{ title }}">
                {{ 'home.bullets.intro' | translate }}
            </h2>
            <h3>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-1.title-start' | translate }} </span>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-1.title-end' | translate }}</span>
            </h3>
            <p class="font-light">
                {{ 'home.bullets.bullet-1.description' | translate }}
            </p>
        </div>
        <div class="flex items-center justify-center p-4 lg:p-8">
            <img id="bullet-1-image" src="assets/images/people-group.png" alt="" class="w-3/4" />
        </div>
    </div>

    <app-home-connector
        startAnchor="bullet-1-text"
        startVertical="bottom"
        startHorizontal="right"
        endAnchor="bullet-2-image"
        endVertical="top"
        endHorizontal="center"
        curveStyle="right-left"
        mobileStartAnchor="bullet-1-image"
        mobileEndAnchor="bullet-2-text"
    />

    <!-- Bullet 2 -->
    <div class="relative z-10 flex flex-col-reverse gap-4 lg:flex-row lg:items-center">
        <div class="flex items-center justify-center p-4 lg:p-8">
            <img id="bullet-2-image" src="assets/images/prototype.png" alt="" class="w-3/4" />
        </div>
        <div id="bullet-2-text" class="flex flex-col justify-center items-start gap-4 lg:pl-4">
            <h3>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-2.title-start' | translate }} </span>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-2.title-end' | translate }}</span>
            </h3>
            <p class="font-light">
                {{ 'home.bullets.bullet-2.description' | translate }}
            </p>
        </div>
    </div>

    <app-home-connector
        startAnchor="bullet-2-image"
        endAnchor="bullet-3-text"
        startHorizontal="center"
        startVertical="bottom"
        endVertical="top"
        endHorizontal="left"
        [curveScale]="0.35"
        curveStyle="right-left"
    />

    <!-- Bullet 3 -->
    <div class="relative z-10 flex flex-col gap-4 lg:flex-row lg:items-center justify-between">
        <div id="bullet-3-text" class="flex flex-col justify-center items-start gap-4 lg:pl-4">
            <h3>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-3.title-start' | translate }} </span>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-3.title-end' | translate }}</span>
            </h3>
            <p class="font-light">
                {{ 'home.bullets.bullet-3.description' | translate }}
            </p>
        </div>
        <div class="flex items-center justify-center p-4 lg:p-8">
            <img id="bullet-3-image" src="assets/images/home_step_3.svg" alt="" class="w-3/4" />
        </div>
    </div>

    <app-home-connector
        startAnchor="bullet-3-text"
        endAnchor="bullet-4-text"
        startVertical="center"
        endVertical="top"
        endHorizontal="left"
        [curveScale]="0.35"
        curveStyle="right-left"
        mobileEndHorizontal="center"
        mobileStartAnchor="bullet-3-image"
        mobileEndAnchor="bullet-4-text"
    />

    <!-- Bullet 4 -->
    <div class="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center justify-between lg:pl-5">
        <img
            class="hidden lg:block scale-x-[-1] aspect-square w-[110px]"
            [ngSrc]="'assets/images/cloud.svg'"
            width="110"
            height="110"
            alt=""
        />
        <div id="bullet-4-text" class="flex flex-col justify-center items-start gap-4 lg:pl-4 lg:w-2/3">
            <h3>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-4.title-start' | translate }} </span>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-4.title-end' | translate }}</span>
            </h3>
            <p class="font-light">
                {{ 'home.bullets.bullet-4.description' | translate }}
            </p>
        </div>
    </div>

    <app-home-connector
        startAnchor="bullet-4-text"
        endAnchor="bullet-5-text"
        startVertical="bottom"
        startHorizontal="center"
        endVertical="top"
        endHorizontal="center"
        [curveScale]="0.35"
        curveStyle="right-left"
        mobileStartAnchor="bullet-4-text"
        mobileEndAnchor="bullet-5-image"
    />

    <!-- Bullet 5 -->
    <div class="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center">
        <div class="flex items-center justify-center p-4 lg:w-1/2 lg:p-8">
            <img id="bullet-5-image" src="assets/images/circle_group.png" alt="" class="w-2/3" />
        </div>
        <div id="bullet-5-text" class="flex flex-col justify-center items-start gap-4 lg:pl-4 lg:w-1/2">
            <h3>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-5.title-start' | translate }} </span>
                <span class="{{ subTitle }}">{{ 'home.bullets.bullet-5.title-end' | translate }}</span>
            </h3>
            <p class="font-light">
                {{ 'home.bullets.bullet-5.description' | translate }}
            </p>
            <div class="mt-4">
                <app-button-link
                    [link]="dashBoardRoute()"
                    [ariaLabel]="'home.apply' | translate"
                    color="primary"
                    [label]="'home.apply' | translate"
                />
            </div>
        </div>
    </div>
</section>
